// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const content = "ModalStatusDescription__content__a9AfO";
export const step = "ModalStatusDescription__step__cY9a7";
export const stepName = "ModalStatusDescription__stepName__4241U font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const stepDescription = "ModalStatusDescription__stepDescription__mnYmk font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const statusIcon = "ModalStatusDescription__statusIcon__FqED+";
export const line = "ModalStatusDescription__line__JGy07";